import { theme } from '../../../../config/theme/theme';

export const TRACER_CONSTANTS = {
  MIN_TABLE_WIDTH: `calc(${theme.breakpoints.values.md}px - var(--secondary-outlet-px) - var(--secondary-outlet-px))`,

  HEADER_HEIGHT: '4.175rem',

  // HEADER: static, always accurate
  // `-1px` necessary to avoid a transparency effect that reveals scrolling
  // content between the header and the accordion
  ACCORDION_STICKY_TOP: 'calc(4.175rem - 1px)',

  // HEADER + ACCORDION: static, always accurate
  RULE_STICKY_TOP: '7.175rem',

  THRESHOLD_MIN_HEIGHT: '8rem',

  // HEADER + ACCORDION + RULE: depends on the current height of the rule, best-effort
  THRESHOLD_BOX_STICKY_TOP: '12.175rem',

  // HEADER + ACCORDION + RULE + CARD: depends on the current heights of the rule and cards, best-effort
  THRESHOLD_INPUT_STICKY_TOP: '18.175rem',
};

export const FUZZER_CONSTANTS = {
  TABS_HEIGHT: '3rem',
  HEADER_HEIGHT: '3.175rem',
  ACCORDION_STICKY_TOP: '6.175rem',
  RULE_STICKY_TOP: '9.175rem',
};
